import { curry, isArray, mergeWith } from 'lodash/fp';
export var mergeReplaceArray = curry(function (object, sources) {
  var customizer = function customizer(objValue, srcValue) {
    return isArray(objValue) && isArray(srcValue) ? srcValue : undefined;
  };

  return mergeWith(customizer, object, sources);
});
export default mergeReplaceArray;